module.exports = __webpack_public_path__ + "static/media/arab.09a95c27.svg";